"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOpacityPercentage = exports.default = void 0;
var _getRgbaFromHex = _interopRequireDefault(require("../utils/getRgbaFromHex"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var getOpacityPercentage = exports.getOpacityPercentage = function getOpacityPercentage(value) {
  if (typeof value !== "number" && !value) {
    return undefined;
  }
  var number = Number(value);
  if (isNaN(number)) {
    return value;
  }
  return number > 1 ? number / 100 : number;
};
var getTranslucentBackground = function getTranslucentBackground(background, opacity) {
  if (!background || typeof opacity === "undefined") {
    return background;
  }
  var number = getOpacityPercentage(opacity);
  if (typeof number === "undefined") {
    return background;
  }
  return (0, _getRgbaFromHex.default)(background, number);
};
var _default = exports.default = getTranslucentBackground;